export const ieo = {
  zzjx: "In progress",
  rgjl: "Subscription record",
  yjjs: "Finished",
  sf: "First release",
  mjze: "Total",
  ckjz: "Progress",
  tips_1:
    "The Biking Startup platform is launched, let's discover the code of wealth with Biking!",
  tips_2: "High-quality projects will be launched soon, look forward to it",
  jyjjks: "About to start",
  ksjy: "Start",
  qjy: "Go to trade",
  xmmc: "Project name",
  xmfjs: 'Introduction to the project party',
  syxm: "All projects",
  banner_1: "Newly launched blockchain project launch platform",
  banner_2:
    "Biking looks for the black horse of blockchain together and opens the road to freedom of wealth",
  ywc: "Completed",
  rgsj: "Subscription time:",
  zcz: "Supporter",
  dqjd: "Progress",
  yck: "Raised",
  sddb: "Token received",
  dff: "To be issued",
  zwxm: "No project yet",
  xq: "Details",
  wksyr: "Preheating not started",
  yrz: "Preheating",
  jxz: "In progress",
  yjs: "Ended",
  ts: "Prompt",
  dbwfjy: "This token is temporarily unavailable for trading",
  ckqtdb: "Please check other tokens",
  xm: "Project",
  ksrg: "Subscription",
  yrg: "Subscribed",
  xmjs: "Project introduction",
  csjg: "Initial price",
  dbzl: "Total amount of tokens: {amount} pieces",
  cssz: "Initial market value: {fdv} dollars",
  xmcytj: "Project participation conditions",
  cjygzh: "Create a Biking account",
  yyzh: "Already have an account, log in directly",
  dlzhjkcy: "Log in to your account to participate in subscription",
  dljkrg: "Log in to your account to subscribe",
  xhzc: "Spot assets",
  zcdy: "Spot assets ≥ 10 USDT",
  rggz: "Subscription rules",
  rgcg: "Subscription successful",
  cgrgxm: "Congratulations! You have successfully subscribed to the project! ",
  fhsy: "Return to home page",
  cyrghd: "Participate in the Biking Startup subscription activity",
  rgje: "Subscription amount",
  xhzcgz: "Spot asset valuation",
  rgsm: "Subscription description:",
  rgsm1: "1. The individual subscription amount is ≥{amount1}USDT; ≤{amount2}USDT;",
  rgsm2:
    "2. The project allocates subscriptions in equal proportions according to the capital investment ratio. If the user subscribes for tokens with an amount greater than the actual allocated amount, after the subscription is completed, the remaining U will be returned to the cash account",
  qd: "Sure",
  dyr: "To be preheated",
  rgdjs: "Subscription countdown",
  yrdjs: "Preheat countdown",
  jykqdjs: "Countdown to transaction start",
  qrg: "Go to subscribe",
  rgjebdy: "The subscription amount is at least {amount} USDT",
  rgjebgy: "The maximum subscription amount shall not exceed {amount} USDT",
  rgjeccdqjc: "Subscription amount exceeds current asset amount",
  fxts1: "1. Start-up projects are still in their infancy, and there may be great risks in the operation of the project, the underlying technology of the project, the legal and regulatory environment, etc.",
  fxts2: "2. Understanding Tokens and assessing their inherent risks requires advanced technical and financial knowledge.",
  fxts3: "3. Affected by technology, laws and regulations, market and other factors, the price of the Token you purchased may fluctuate violently, and the price may decrease or increase significantly.",
  fxts4: "4. Due to the underlying technology of the Token or the BIKING trading platform, the Token you purchased may not be fully or partially withdrawn.",
  sfpt: "Blockchain project launch platform",
  xmhzsq: "Project cooperation",
  hdlx: "Type",
  yryq: "One Signature",
  yrdq: "Multiple Signatures",
  hdjg: "Price",
  hdsl: "Quantity",
  zqs: "Total",
  rgqs: "Subscription number of signatures",
  rgsl: "Subscription quantity",
  mqsl: "Number per signature",
  mrzgqs: "Maximum Signatures",
  qian: "Signature",
  lian: "Chain",
  hdrgsm: "Subscription instructions: After winning the lottery, the total number of winning users will be randomly selected from all winning users. If the subscription fails, the USDT used for the failed subscription will be returned at the same time as the winning airdrop is issued.",
  jqqd: "Look forward to the lottery results",
  dbffkjy: "Tokens can be traded after issuance",
  dzjgb: "Waiting for the lottery announcement",
  dzq: "Waiting for the lottery",
  ffzt: "Distribution status",
  dbff: "Winning tokens issued",
  yff: "Issued",
  wzq: "Not Winning the Lottery",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/en.js